// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"85408396","453":"7a250c99","738":"faa49c65"}[chunkId] + ".chunk.js";
};